import { lazy, Suspense } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftPotOrganizer = lazy(
  () => import(/* webpackChunkName: 'GiftPotOrganizer' */ './Organizer'),
);

export default function GiftPotOrganizer({
  match,
}: RouteComponentProps<{ slug: string }>) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftPotOrganizer key={match.params.slug} slug={match.params.slug} />
    </Suspense>
  );
}
